let blocks = document.querySelectorAll('.page-home--portfolios .image-area a');
let elementSpan = [];

function coordinatesInElementStyles(item, index) {
	let target = item.target.closest('a');
	let targetCoords = target.getBoundingClientRect();
	let xCoord = item.clientX - targetCoords.left;
	let yCoord = item.clientY - targetCoords.top;
	elementSpan[index].style.left = xCoord + "px";
	elementSpan[index].style.top = yCoord + "px";
}

blocks.forEach((item, index) => {
	if (!elementSpan[index]) {
		elementSpan[index] = item.querySelector('.image-mask');
	}

	item.addEventListener('mouseover', (e) => {
		coordinatesInElementStyles(e, index);
	});

	item.addEventListener('mouseout', (e) => {
		coordinatesInElementStyles(e, index);
	})
});